import API from 'services/API';

export default function saveCodeWord(data) {
  return API.request({
    method: 'POST',
    url: '/profile/submitCodeWord',
    data,
  });
}
